import styled from 'styled-components'

import { minmedia } from '../../../styles/media-queries'
import { white, bordergray, lightergray } from '../../../styles/colors'

export const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  background: ${white};
  border-bottom: 1px solid ${bordergray};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  position: relative;

  ${minmedia.xmlarge`
    display: none;
  `};
`

export const Filler = styled.div`
  height: 65px;
  width: 62px;
`

export const LogoContainer = styled.div`
  position: ${props => (props.big ? 'absolute' : 'relative')};
  top: ${props => (props.big ? '1.5rem' : '0')};
  left: ${props => (props.big ? '50%' : '0')};
  transform: ${props => (props.big ? 'translateX(-50%)' : 'none')};
  &.big {
    position: absolute;
    top: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
  }
`

export const IconContainer = styled.div`
  transition: background-color 0.5s;
  cursor: pointer;
  padding: 1rem;

  &:hover {
    background-color: ${lightergray};
  }

  svg {
    width: 30px;
    height: 30px;
  }
`



// WEBPACK FOOTER //
// ./src/components/MobileHeader/TopBar/styles.js